export const LISTBOX_MAX_HEIGHT = "240px";
export const LISTBOX_OVERFLOW = "auto";
export const CHECKBOX_MARGIN_RIGHT = 8;
